export default "__VITE_ASSET__89504abe__"